import datapoints from '../datapoints';
import createReferenceAttachmentFromAttachmentDataProviderService from '../services/createReferenceAttachmentFromAttachmentDataProvider';
import CreateAttachmentResult from '../types/CreateAttachmentResult';
import { getErrorForAttachmentCreationFailure } from '../utils/getErrorForAttachmentCreationFailure';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { CloudFile } from 'owa-attachment-file-types';
import { ClientItemId } from 'owa-client-ids';
import AttachmentInfoResponseMessage from 'owa-service/lib/contract/AttachmentInfoResponseMessage';
import {
    AttachmentFullViewState,
    AttachmentState,
    AttachmentStateType,
    setActionCompletePercent,
    startFakeProgressIndicator,
    stopFakeProgressIndicator,
} from 'owa-attachment-full-data';

export default createLegacyActionWithDatapoint(
    'createReferenceAttachmentFromAttachmentDataProvider',
    datapoints.AttachmentCreationCloudyFromAttachmentDataProvider
)(async function createReferenceAttachmentFromAttachmentDataProvider(
    parentItemId: ClientItemId,
    cancellationId: string,
    backingObject: CloudFile,
    attachmentState: AttachmentState
): Promise<CreateAttachmentResult> {
    if (attachmentState.attachmentType === AttachmentStateType.Attachment) {
        startFakeProgressIndicator(
            4000, // For createReferenceAttachmentFromAttachmentDataProvider the calltime does not depend on file size
            // 4000 was choosen to give a smooth progress bar for the average user.
            0.05, // Update the progress bar about every fifth of a second for a smooth bar (4000ms*.05 = 200ms = .2 seconds).
            (completePercent: number) => {
                setActionCompletePercent(<AttachmentFullViewState>attachmentState, completePercent);
            },
            attachmentState.attachmentId
        );
    }

    return createReferenceAttachmentFromAttachmentDataProviderService(
        parentItemId,
        cancellationId,
        backingObject
    ).then(createAttachmentResponse => {
        const responseMessage: AttachmentInfoResponseMessage =
            createAttachmentResponse.ResponseMessages.Items[0];
        if (responseMessage && responseMessage.Attachments.length > 0) {
            stopFakeProgressIndicator(attachmentState.attachmentId, true);
            const result: CreateAttachmentResult = {
                attachment: responseMessage.Attachments[0],
                sharingInfo: createAttachmentResponse.SharingInformation,
            };
            return result;
        } else {
            stopFakeProgressIndicator(attachmentState.attachmentId, false);
            throw getErrorForAttachmentCreationFailure(responseMessage);
        }
    });
});
